<template><div><!--THIS FILE IS AUTOGENERATED, DONOT EDIT IT-->
<h2>dialog</h2>
<hr>
<h3>Actionsheet_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/actionsheet/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/actionsheet">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/actionsheet" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Actionsheet.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Actionsheet } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">value</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if showing the component; use v-model for binding</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">show-cancel</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if showing the cancel menu; invalid for android theme</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">cancel-text</span></td>
<td><span class="type type-string">String</span></td>
<td>cancel(取消)</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>text of cancel menu</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">theme</span></td>
<td><span class="type type-string">String</span></td>
<td>ios</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>theme of menus, can be in [‘ios’, ‘android’]</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">menus</span></td>
<td><span class="type type-object">Object</span><br><span class="type type-array">Array</span></td>
<td>{}</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>menu items, for example: <code>{menu1: 'some text'}</code>, menu name with <code>.noop</code> will not trigger click events. <br><code>Menus</code> supports array since <code>v2.1.0</code>. Keys can be customized. More details below.</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">close-on-clicking-mask</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>true</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.0.0</span></td>
<td>if closing actionsheet when clicking on mask</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">close-on-clicking-menu</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>true</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.3.8</span></td>
<td>if hide automatically when clicking on menus</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Events</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-click-menu</span></td>
<td>(menuKey, menuItem)</td>
<td>triggers when clicking on the menu</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-click-menu-{menuKey}</span></td>
<td>(menuKey)</td>
<td>shortcut event for easier listening, <code>menuKey</code> is related to <code>label</code>. For exapmple, you can listen on <code>on-click-menu-delete</code> if you have a menu named <code>delete</code></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-click-menu-cancel</span></td>
<td> </td>
<td>triggers when clicking on the cancel menu</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-click-mask</span></td>
<td> </td>
<td>triggers when clicking on mask</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.3.4</span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/actionsheet">Demo page</a></p>
<p>From <code>v2.1.0</code>, <code>menus</code> supports type: Array.</p>
<p><code>label</code>: label name，you can use simple text or <code>html</code></p>
<p><code>value</code>: event name，if not specified, no <code>on-click-menu</code> will be emitted</p>
<p><code>type</code>:</p>
<ul>
<li><code>primary</code> primary color</li>
<li><code>warn</code> warn color</li>
<li><code>disabled</code> gray color, the menu cannot be clicked</li>
<li><code>info</code> the menu item shows as a tip, the same function as <code>key.noop</code> when setting menus by <code>Object</code>.</li>
</ul>
<pre class="hljs"><code>[{
  <span class="hljs-attr">label</span>: <span class="hljs-string">'Are you sure?&lt;br/&gt;&lt;span style="color:#666;font-size:12px;"&gt;Once deleted, you will never find it.&lt;/span&gt;'</span>,
  <span class="hljs-attr">type</span>: <span class="hljs-string">'info'</span>
}, {
  <span class="hljs-attr">label</span>: <span class="hljs-string">'Primary'</span>,
  <span class="hljs-attr">type</span>: <span class="hljs-string">'primary'</span>,
  <span class="hljs-attr">value</span>: <span class="hljs-string">'primary'</span>
}, {
  <span class="hljs-attr">label</span>: <span class="hljs-string">'Warn'</span>,
  <span class="hljs-attr">type</span>: <span class="hljs-string">'warn'</span>
}, {
  <span class="hljs-attr">label</span>: <span class="hljs-string">'Disabled'</span>,
  <span class="hljs-attr">type</span>: <span class="hljs-string">'disabled'</span>
}, {
  <span class="hljs-attr">label</span>: <span class="hljs-string">'Default'</span>
}]
</code></pre>
<hr>
<h3>Alert_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/alert/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/alert">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/alert" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Alert.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Alert } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p>This component can be imported as plugin:</p>
<p class="warning">
When importing it as plugin, the usage is different from it in `template`. Please use  `little camel-case`  such as `buttonText` instead of `button-text`.
</p>
<pre class="hljs"><code><span class="hljs-keyword">import</span>  { AlertPlugin } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
Vue.use(AlertPlugin)

<span class="hljs-comment">// or the way of umd</span>
<span class="hljs-comment">// import built js file</span>
Vue.use(vuxAlertPlugin)
</code></pre>
<pre class="hljs"><code><span class="hljs-comment">// show</span>
<span class="hljs-keyword">this</span>.$vux.alert.show({
  <span class="hljs-attr">title</span>: <span class="hljs-string">'Vux is Cool'</span>,
  <span class="hljs-attr">content</span>: <span class="hljs-string">'Do you agree?'</span>,
  onShow () {
    <span class="hljs-built_in">console</span>.log(<span class="hljs-string">'Plugin: I\'m showing'</span>)
  },
  onHide () {
    <span class="hljs-built_in">console</span>.log(<span class="hljs-string">'Plugin: I\'m hiding'</span>)
  }
})
<span class="hljs-comment">// hide</span>
<span class="hljs-keyword">this</span>.$vux.alert.hide()
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">value</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>visibility of the component, use v-model for binding</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">title</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>title</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">content</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.2.0</span></td>
<td>alert content, and will be replaced if using slot:default</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">button-text</span></td>
<td><span class="type type-string">String</span></td>
<td>ok(确定)</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>button text</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">hide-on-blur</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if closing dialog when clicking on mask</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">mask-transition</span></td>
<td><span class="type type-string">String</span></td>
<td>vux-fade</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>mask transition</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">dialog-transition</span></td>
<td><span class="type type-string">String</span></td>
<td>vux-dialog</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>dialog transition</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">mask-z-index</span></td>
<td><span class="type type-number">Number</span><br><span class="type type-string">String</span></td>
<td>1000</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.6.4</span></td>
<td>zIndex of mask</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">default</span></td>
<td>dialog content</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Events</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-show</span></td>
<td> </td>
<td>emits when dialog shows</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-hide</span></td>
<td> </td>
<td>emits when dialog is closed</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/alert">Demo page</a></p>
<hr>
<h3>Confirm_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/confirm/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/confirm">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/confirm" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Confirm.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Confirm } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">show</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>visibility of the component</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">show-input</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.5.0</span></td>
<td>whether show input or not. If true, slot will not work</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">placeholder</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.5.0</span></td>
<td>placeholder of prompt, valid when show-input is true</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">theme</span></td>
<td><span class="type type-string">String</span></td>
<td>ios</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>dialog’s style, can be ios or android</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">hide-on-blur</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if closing dialog when clicking on mask</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">title</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>dialog title</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">content</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>dialog content, can use html. Invalid when using slot</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">confirm-text</span></td>
<td><span class="type type-string">String</span></td>
<td>确认(confirm)</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>text of confirm button</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">cancel-text</span></td>
<td><span class="type type-string">String</span></td>
<td>取消(cancel)</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>text of cancel button</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">mask-transition</span></td>
<td><span class="type type-string">String</span></td>
<td>vux-fade</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>mask’s transition</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">dialog-transition</span></td>
<td><span class="type type-string">String</span></td>
<td>vux-dialog</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>dialog’s transition</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">close-on-confirm</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>true</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.5.0</span></td>
<td>whether close automatically when confirm button is clicked</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">input-attrs</span></td>
<td><span class="type type-object">Object</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.5.7</span></td>
<td>input attributes</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">mask-z-index</span></td>
<td><span class="type type-number">Number</span><br><span class="type type-string">String</span></td>
<td>1000</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.6.4</span></td>
<td>zIndex of mask</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">default</span></td>
<td>body content of the dialog</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Events</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-cancel</span></td>
<td> </td>
<td>triggers when the cancel button is clicked</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-confirm</span></td>
<td>(value)</td>
<td>triggers when the confirm button is clicked</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-show</span></td>
<td> </td>
<td>triggers when the dialog shows</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-hide</span></td>
<td> </td>
<td>triggers when the dialog hides</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Methods</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">v2.6.4</span></td>
<td> </td>
<td>[feature] support prop:mask-z-index</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">setInputValue</span></td>
<td>(value)</td>
<td>set input value when show-input is true</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.5.5</span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/confirm">Demo page</a></p>
<hr>
<h3>Loading_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/loading/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/loading">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/loading" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Loading.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Loading } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">show</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>visibility of the component. Use <code>v-model</code> for binding before v2.5.7, otherwise use <code>:show</code></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">text</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>loading text</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">position</span></td>
<td><span class="type type-string">String</span></td>
<td>fixed</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>position, default is <code>fixed</code>, you can use <code>absolute</code></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">transition</span></td>
<td><span class="type type-string">String</span></td>
<td>vux-mask</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>transition name</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">default</span></td>
<td>content area</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/loading">Demo page</a></p>
<hr>
<h3>Popup_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/popup/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/popup">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/popup" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Popup.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Popup } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">value</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>visibility of popup, use <code>v-model</code> for binding</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">height</span></td>
<td><span class="type type-string">String</span></td>
<td>auto</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>popup height, works when position is top or bottom</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">hide-on-blur</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>true</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if closing popup when mask being clicked</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">is-transparent</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.1.1-rc.9</span></td>
<td>if using transparent background</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">width</span></td>
<td><span class="type type-string">String</span></td>
<td>auto</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.2.1-rc.6</span></td>
<td>if you want to set 100% width, you should use this prop. only works when position is left or right</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">position</span></td>
<td><span class="type type-string">String</span></td>
<td>bottom</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.2.1-rc.6</span></td>
<td>popup position, shoule be one of [‘left’, ‘right’, ‘top’, ‘bottom’]</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">show-mask</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>true</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.2.1-rc.6</span></td>
<td>whether show mask</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">popup-style</span></td>
<td><span class="type type-object">Object</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.5.2</span></td>
<td>popup style</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">hide-on-deactivated</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>true</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.5.5</span></td>
<td>whether hide popup on deactived event when using keep-alive</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">default</span></td>
<td>content body</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Events</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-hide</span></td>
<td> </td>
<td>emits when then popup is closed</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-show</span></td>
<td> </td>
<td>emits when the popup shows</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-first-show</span></td>
<td> </td>
<td>emits at the first time the popup shows</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/popup">Demo page</a></p>
<hr>
<h3>Toast_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/toast/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/toast">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/toast" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Toast.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Toast } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">value</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if showing toast, use v-model for binding</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">time</span></td>
<td><span class="type type-number">Number</span></td>
<td>2000</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>show time</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">type</span></td>
<td><span class="type type-string">String</span></td>
<td>success</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>toast type, success, warn, cancel, text</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">width</span></td>
<td><span class="type type-string">String</span></td>
<td>7.6em</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>toast’s width</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">is-show-mask</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if showing mask, users cannot operate other elements on the page</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">text</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>content of the toast, text or html, the same function as default slot</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">position</span></td>
<td><span class="type type-string">String</span></td>
<td>default</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.1.1-rc.4</span></td>
<td>toast position, available values: default, top, middle, bottom</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">default</span></td>
<td>default slot, the content of the toast</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Events</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-show</span></td>
<td> </td>
<td>emits when toast shows</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-hide</span></td>
<td> </td>
<td>emits when toast hides</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/toast">Demo page</a></p>
<hr>
<h3>XDialog_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/x-dialog/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/x-dialog">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/x-dialog" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/XDialog.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { XDialog } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p class="warning">
if you use `XDialog` inside `ViewBox` or use `overflowScrolling:touch`，please should import `directive:transfer-dom` to fix `z-index` invalid issue。
<br>
<br>
otherwise, you don't need to use `v-transfer-dom`.
</p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { TransferDomDirective <span class="hljs-keyword">as</span> TransferDom } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>

<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  <span class="hljs-attr">directives</span>: {
    TransferDom
  }
}

</code></pre>
<pre class="hljs"><code><span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">v-transfer-dom</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">x-dialog</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">x-dialog</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">show</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>visibility of the dialog, supports the .sync modifier</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">mask-transition</span></td>
<td><span class="type type-string">String</span></td>
<td>vux-mask</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>transition of mask</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">dialog-transition</span></td>
<td><span class="type type-string">String</span></td>
<td>vux-dialog</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>transition of dialog body</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">hide-on-blur</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if closing dialog when clicking on mask</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">scroll</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>true</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>[deprecated]if body content can scroll when scrolling on dialog</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">dialog-style</span></td>
<td><span class="type type-object">Object</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.2.2</span></td>
<td>set dialog styles, you can use it for overwritting default width and background style</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">mask-z-index</span></td>
<td><span class="type type-number">Number</span><br><span class="type type-string">String</span></td>
<td>1000</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.6.4</span></td>
<td>zIndex of mask</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">default</span></td>
<td>main content of the dialog</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Events</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-show</span></td>
<td> </td>
<td>emits when opening dialog</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-hide</span></td>
<td> </td>
<td>emits when closing dialog</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/x-dialog">Demo page</a></p>
</div></template><script>
export default {
  head: {"title":" | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// components_dialog-3.vue?21b82baa